module.exports = __webpack_public_path__ + "img/chat_send_file.053dc5dc.svg";